import { useCalculateTotalPathDistance } from "./useCalculateTotalPathDistance";
import { useCalculateTravelHours } from "./useCalculateTravelHours";

export const useCalculateAverageSpeedByPath = () => {
  const totalDistance = useCalculateTotalPathDistance();
  const travelHours = useCalculateTravelHours();

  return Math.round(totalDistance / travelHours);
};
